import { useEffect, useRef } from 'react';

export interface TranscriptTurn {
  role: 'callee' | 'ai';
  text: string;
  isFinal: boolean;
  ts: number;
}

export function Transcript({ turns, autoScroll }: { turns: TranscriptTurn[]; autoScroll?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!autoScroll) return;
    const el = ref.current;
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [turns.length, autoScroll]);

  if (turns.length === 0) {
    return (
      <div className="transcript-empty">
        Waiting for the call to begin…
      </div>
    );
  }

  return (
    <div className="transcript">
      {turns.map((t, i) => (
        <div className="transcript-turn" key={`${t.ts}-${i}`}>
          <div className={`turn-role turn-role-${t.role}`}>
            {t.role === 'ai' ? 'Operator' : 'Callee'}
          </div>
          <div className={`turn-text${t.isFinal ? '' : ' partial'}`}>{t.text}</div>
        </div>
      ))}
      <div ref={ref} />
    </div>
  );
}
